import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray, UntypedFormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductPageService } from '@services/productPage.service';
import { OptionsEventService } from '@services/optionsEvent.service';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgFor, KeyValuePipe } from '@angular/common';

@Component({
    selector: 'app-product-variants-options',
    templateUrl: './product-variants-options.component.html',
    styleUrls: ['./product-variants-options.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, NgIf, NgFor, MatFormFieldModule, MatSelectModule, MatOptionModule, KeyValuePipe, TranslateModule]
})
export class ProductVariantsOptionsComponent implements OnInit, OnChanges {
    constructor(private ref: ChangeDetectorRef,
        private router: Router,
        public optionsEventService: OptionsEventService,
        private fb: UntypedFormBuilder,
        private productPageService: ProductPageService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper) { }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.optionsObject?.currentValue) {
            this.variants = changes.optionsObject?.currentValue;
        }

    }

    @Input() baseForm: UntypedFormGroup;

    @Input() optionsObject;

    variants;

    @Input() product;

    @Output() optionChanged: EventEmitter<any> = new EventEmitter();



    ngOnInit(): void {


        this.variants = this.optionsObject;

    }



    selectionChange(seo) {

        this.baseForm.get('amount').setValue(this.product.quantity?.min || 1);
        this.router.navigate(
            [...(this.product.sector?.seo?.slug) ?
                ['/sector', this.product.sector?.seo?.slug]
                :
                '/', this.product.layout || this.product.type, seo],
            { queryParams: { v: 'v' } });

    }


}
